import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { ICDDQuestion } from '../../../types/cddQuestions';
import { RootState } from '../..';

export interface IGetCddQuestionsResponse {
  status?: boolean;
  message?: string;
  data?: ICDDQuestion[];
  errors?: IApiResponseError[];
}

const initialState: IApiState<IGetCddQuestionsResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const getCddQuestionsAsync = createAsyncThunk(
  'kyb/cddQuestions',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;

      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
        },
      };

      const { data } = await api.get(`cdd/questions`, config);

      return data;
    } catch (err) {
      const error = err as AxiosError<IApiResponseError>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const cddQuestionsGetSlice = createSlice({
  name: 'kyb/cddQuestions/get',
  initialState,
  reducers: {
    resetGetCddQuestions: (state) => {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCddQuestionsAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(getCddQuestionsAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IGetCddQuestionsResponse;
      })
      .addCase(getCddQuestionsAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IGetCddQuestionsResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetGetCddQuestions } = cddQuestionsGetSlice.actions;

export default cddQuestionsGetSlice.reducer;
